






























import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { IStyle } from '~/assets/interfaces/classes'
import { ICatalogLabel } from '~/assets/interfaces/catalog'
import { isAbsoluteUrl } from '~/assets/functions/url'

@Component
export default class ComponentCatalogLabels extends Vue {
  @Prop({ type: Array, default: () => [] }) private items!: ICatalogLabel[]
  @Prop({ type: Boolean, default: false }) private small!: boolean
  // Режим «поверх фото в плитке»: столбиком и мелко. Текст не обрезаем —
  // в лейбле бывает дата доставки, и «Привезём 23 сент…» хуже переноса.
  @Prop({ type: Boolean, default: false }) private compact!: boolean
  // Вместе с compact: те же мелкие плашки, но в ряд с переносом — для места
  // над названием, а не поверх фото.
  @Prop({ type: Boolean, default: false }) private inline!: boolean
  // Сколько лейблов показать; 0 — все. На фото больше двух не помещается
  // без того, чтобы закрыть сам товар.
  @Prop({ type: Number, default: 0 }) private max!: number

  private get visibleItems() {
    return this.max > 0 ? this.items.slice(0, this.max) : this.items
  }

  private $style!: IStyle

  private classItem(item: ICatalogLabel) {
    let temp = { [this.$style.item]: true }
    temp = Object.assign(temp, {
      [this.$style.error]: item.color === 'error',
      [this.$style.secondary]: item.color === 'secondary',
      [this.$style.success]: item.color === 'success',
      [this.$style.gray]: item.color === 'gray',
      [this.$style.primary]: item.color === 'primary',
      [this.$style.small]: this.small,
    })
    return temp
  }

  private styleItem(item: ICatalogLabel) {
    const style: { background?: string; color?: string } = {}
    if (/^#([0-9A-F]{3}){1,2}$/i.test(item.color)) {
      style.background = item.color
    }
    if (item.textColor) {
      style.color = item.textColor
    }
    return style
  }

  private componentItem(item: ICatalogLabel) {
    if (item.url) {
      if (isAbsoluteUrl.test(item.url)) {
        return 'a'
      } else {
        return 'nuxt-link'
      }
    }
    return 'div'
  }

  private mounted() {
    this.$emit('loaded')
  }
}
